//External Dependencies
import React, { Component } from "react";
//Internal Dependencies
import AsyncComponent from "../../../components/async-component";
import { DemandsListProvider } from "./context/DemandsListContext";
import { updateBreadcrumb } from "../../../utils/breadcrumbs";
import PageContent from "../../../components/page-content";
import PageWrap from "../../../components/page-wrap";

//Component
class DemandsList extends Component {
    componentDidMount = updateBreadcrumb;

    render() {
        return (
            <PageWrap>
                <PageContent>
                    <DemandsListProvider>
                        <AsyncComponent component={() => import("./content")} />
                    </DemandsListProvider>
                </PageContent>
            </PageWrap> 
        );
    }
}

export default DemandsList;
